import { computed, Injectable, signal } from '@angular/core';
import { AuthSession } from '../../model/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly _session = signal<AuthSession | null>(null);

  readonly session = this._session.asReadonly();
  readonly isAuthenticated = computed(() => this._session() !== null);
  readonly groups = computed(() => this._session()?.user.groups ?? []);

  isInGroup(name: string): boolean {
    return this.groups().includes(name);
  }

  setSession(session: AuthSession): void {
    this._session.set(session);
  }

  clearSession(): void {
    this._session.set(null);
  }
}
